import React, { useState } from "react";
import CryptoJS from "crypto-js";
import { Button, Form, Container, Row, Col, Card } from 'react-bootstrap';

const Encrypt = () => {
    const [data, setData] = useState('');
    const [encryptedData, setEncryptedData] = useState('');
    const [decryptedData, setDecryptedData] = useState('');

    const secretKey = "mySecretKey123"; // Kunci rahasia untuk enkripsi dan dekripsi

    const encryptData = () => {
        const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString();
        setEncryptedData(encrypted);
    };

    const decryptData = () => {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        setDecryptedData(decrypted);
    };

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="shadow-lg rounded">
                        <Card.Body>
                            <h3 className="text-center mb-4">Enkripsi dan Dekripsi Data</h3>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data yang ingin dienkripsi:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Masukkan data"
                                        value={data}
                                        onChange={(e) => setData(e.target.value)}
                                        className="border-0 shadow-sm"
                                    />
                                </Form.Group>

                                <div className="d-flex justify-content-center mb-4">
                                    <Button
                                        variant="primary"
                                        onClick={encryptData}
                                        className="px-5 py-2 me-2"
                                        style={{ fontSize: "16px", fontWeight: "500" }}
                                    >
                                        Enkripsi Data
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        onClick={decryptData}
                                        className="px-5 py-2"
                                        style={{ fontSize: "16px", fontWeight: "500" }}
                                    >
                                        Dekripsi Data
                                    </Button>
                                </div>

                                <Form.Group className="mb-3">
                                    <Form.Label>Hasil Enkripsi:</Form.Label>
                                    <textarea
                                        rows={4}
                                        value={encryptedData}
                                        readOnly
                                        className="form-control border-0 shadow-sm"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Hasil Dekripsi:</Form.Label>
                                    <textarea
                                        rows={4}
                                        value={decryptedData}
                                        readOnly
                                        className="form-control border-0 shadow-sm"
                                    />
                                </Form.Group>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Encrypt;
